.down {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: calc(16px + var(--inset-top, 0px)) 0 16px;
  text-align: center;
}

.title {
  margin: 0;
  font-family: var(--font-display);
  font-style: italic;
  font-weight: 500;
  font-size: 24px;
  line-height: 1.15;
}

.lead {
  margin: 0 0 8px;
  font-size: 14px;
  color: var(--muted);
}

.retry {
  margin: 8px 0 0;
  font-size: 13px;
  color: var(--muted);
}

.retry button {
  margin-left: 4px;
  border: 1px solid var(--line);
  border-radius: 999px;
  padding: 5px 14px;
  background: none;
  color: var(--text);
  font: inherit;
  cursor: pointer;
}
